import { IDropDownOptions } from "../Component/Common/Components/FormValidationInputs/AppRadioButtons";
import { DataImportType, ImportActions, ScorecardTypes } from "../Component/Model/Enum/BEE123Enums";
import { ScorecardTypesHelperFunctions } from "../Component/Model/Enum/EnumHelperFunctions/EnumHelperFunctions";

export interface IOptions {
    Id: number;
    Name: string;
}
export const ImportCommonFunctions = (importTypeId: string) => {
    var importActionOptions = Array<IOptions>();
    if (!importTypeId) {
        return importActionOptions;
    }
    if (importTypeId === DataImportType[DataImportType.IndividualSalary] || 
        importTypeId === DataImportType[DataImportType.CertificateRegistry] ||
        importTypeId === DataImportType[DataImportType.EESalary]) {
        importActionOptions.push({ Id: ImportActions.Append, Name: 'New Import / Append to current data' });
    }
    else if (importTypeId === DataImportType[DataImportType.Person] ||
            importTypeId === DataImportType[DataImportType.Salary] || 
            importTypeId === DataImportType[DataImportType.VerificationAgencyClient]) {
        importActionOptions.push({ Id: ImportActions.Append, Name: 'New Import / Append to / Update existing data' });
    } 
    else {
        importActionOptions.push({ Id: -1, Name: 'Select' });
        if (importTypeId === DataImportType[DataImportType.EmployeeStructure] ||
            importTypeId === DataImportType[DataImportType.BoardParticipation] ||
            importTypeId === DataImportType[DataImportType.PeopleManagement]) {
            importActionOptions.push({ Id: ImportActions.Append, Name: 'New Import / Append to / Update existing data' });
        }
        else {
            importActionOptions.push({ Id: ImportActions.Append, Name: 'New Import / Append to current data' });
        }

        importActionOptions.push({ Id: ImportActions.Overwrite, Name: 'Overwrite all current data' });

        if (importTypeId === DataImportType[DataImportType.PreferentialProcurement]) {
            importActionOptions.push({ Id: ImportActions.UpdateAndReplaceYearToDateSpendValues, Name: 'Update current data: Replace with new Year-to-date spend values' });
            importActionOptions.push({ Id: ImportActions.UpdateAndAddSpendValuesToExistingTotalSpendValues, Name: 'Update current data: Add spend values to the existing total spend' });
        }
    }
    return importActionOptions;
}

export const ImportCommonFunctionsDropDown = (importTypeId: string) => {
    var importActionOptions = Array<IDropDownOptions>();
    if (!importTypeId) {
        return importActionOptions;
    }
    if (importTypeId === DataImportType[DataImportType.Individual] ) {
        importActionOptions.push({ id: ImportActions.Append, value: 'New Import / Append to current data / Update existing data ' });
        importActionOptions.push({ id: ImportActions.Overwrite, value: 'Overwrite all current data' });
    }
    else if (importTypeId === DataImportType[DataImportType.IndividualSalary] || 
        importTypeId === DataImportType[DataImportType.PlatformSalary] ||
        importTypeId === DataImportType[DataImportType.MerSetaTraining] || 
        importTypeId === DataImportType[DataImportType.EESalary]) {
        importActionOptions.push({ id: ImportActions.Append, value: 'New Import / Append to current data' });
    }
    else if (importTypeId === DataImportType[DataImportType.Person] || importTypeId === DataImportType[DataImportType.Salary]  ){
        importActionOptions.push({ id: ImportActions.Append, value: 'New import / Append to / Update existing data' });
    } 
    else if (importTypeId === DataImportType[DataImportType.JobTitle] ) {
        importActionOptions.push({ id: ImportActions.Append, value: 'New Import / Append to current data' });
        importActionOptions.push({ id: ImportActions.Overwrite, value: 'Overwrite all current data' });
    }
    else {
        importActionOptions.push({ id: -1, value: 'Select' });
        if (importTypeId === DataImportType[DataImportType.EmployeeStructure] ||
            importTypeId === DataImportType[DataImportType.BoardParticipation] ||
            importTypeId === DataImportType[DataImportType.PeopleManagement]) {
            importActionOptions.push({ id: ImportActions.Append, value: 'New Import / Append to / Update existing data' });
        }
        else {
            importActionOptions.push({ id: ImportActions.Append, value: 'New Import / Append to current data' });
        }

        importActionOptions.push({ id: ImportActions.Overwrite, value: 'Overwrite all current data' });

        if (importTypeId === DataImportType[DataImportType.PreferentialProcurement]) {
            importActionOptions.push({ id: ImportActions.UpdateAndReplaceYearToDateSpendValues, value: 'Update current data: Replace with new Year-to-date spend values' });
            importActionOptions.push({ id: ImportActions.UpdateAndAddSpendValuesToExistingTotalSpendValues, value: 'Update current data: Add spend values to the existing total spend' });
        }
    }

    return importActionOptions;
}

export const DataImportTypesLookups = [

    ['none', 0],
    ['employeestructure', 1],
    ['boardparticipation', 2],
    ['verificationagencyclient', 3],
    ['combinedskillsdevelopmentindividual', 4],
    ['skillsdevelopmentexternal', 5],
    ['skillsdevelopmentinternal', 6],
    ['skillsdevelopmentlearnership', 7],
    ['preferentialprocurement', 8],
    ['preferentialprocurementexcludableimports', 9],
    ['individualsalary', 10],
    ['ownership', 11],
    ['financialsupport', 12],
    ['disposalofassets', 13],
    ['economicdevelopmentcontributions', 14],
    ['totalmeasuredprocurementspend', 15],
    ['investmentsunderresourced', 16],
    ['generalinformation', 17],
    ['equityequivalent', 18],
    ['socioeconomicdevelopment', 19],
    ['skillsdevelopmentrelatedstaffsalaries', 20],
    ['peoplemanagement', 21],
    ['company', 22],
    ['scorecardsummary', 23],
    ['affordablehousingfinancing', 24],
    ['agriculturalfinancing', 25],
    ['transactionfinancing', 26],
    ['transformationalinfrastructurefinancing', 27],
    ['skillsdevelopmenthebursaries', 28],
    ['intragroupspend', 29],
    ['enterprisedevcontributions', 30],
    ['accesstofinancialservices', 31],
    ['blackownedsmallandmedium', 32],
    ['blackbusinessgrowthfunding', 33],
    ['skillsdevelopmentleviableamount', 34],
    ['supplierearlypayment', 35],
    ['enterpriseearlypayment', 36],
    ['generalexpense', 37],
    ['supplierdevcontributions', 38],
    ['rsmcontribution', 39],
    ['tracktraineereport', 40],
    ['usertracking', 41],
    ['supplieranalysis', 42],
    ['skillsdevelopmentmatrix', 43],
    ['employmentequityemployeestructure', 44],
    ['person', 45],
    ['individual', 45],
    ['salary', 46],
    ['certificateregistry', 49],
    ['eesalary', 46], 
    ['platformpeople', 51],
    ['eeindividualgroupimport', 62],
    ['eesalarygroupimport', 63]
];


export const getUploadFileName = (uploadType: string) => {

    uploadType = (uploadType ?? '').toLowerCase();
    var filename = uploadType;
    return filename;
}

enum DataImportTypesCode {
    name,
    id
  }

export const dataImportTypeLookupVal = (lookupValue: string, sourceCode: DataImportTypesCode, destCode: DataImportTypesCode) => {
    let item = DataImportTypesLookups.find(x => x[sourceCode].toString().toLowerCase() === lookupValue.toString().toLowerCase());
    switch (destCode) {
        case DataImportTypesCode.name:
            return (item && item[destCode]) || '';
        case DataImportTypesCode.id:
            return (item && item[destCode]) || 0;
        default:
            return null;
    }
}

